import { useEffect, useState } from "react";
import { Card } from "../../../components/card/card";
import { dataTel3GetOutstanding } from "../../../config/apiSPA";
import DateFormat from "../../../components/dateFormater/dateFormat1";
import Pagination3 from "../../../components/pagination/pagination3";
import { MdFormatListBulletedAdd } from "react-icons/md";
import { Link } from "react-router-dom";
const dataPreset = {
  data: [],
  meta: null,
};
function DataOutstanding() {
  const [data, setData] = useState(dataPreset);
  const [search1Value, setSearch1Value] = useState("");
  const handleNextClick = () => {
    loadData(search1Value, data.meta.current_page + 1);
  };
  const handlePrevClick = () => {
    loadData(search1Value, data.meta.current_page - 1);
  };
  const handleSubmitSearch = (e) => {
    e.preventDefault();
    loadData(search1Value, "");
  };
  const loadData = async (s = "", p = "") => {
    try {
      const res = await dataTel3GetOutstanding(s, p);
      setData(res);
    } catch (error) {}
  };

  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <h3 className="text-danger">Outstanding</h3>
      <p>Contains data that has not been registered for Level 3 training evaluation after 3 months of training implementation.</p>
      <Card>
        <div className="tab-content p-4">
          {/* ----------------All Tab------------------------------------------------------------------ */}
          <div className="tab-pane fade show active" id="allTab">
            <form onSubmit={handleSubmitSearch}>
              <div className="input-group mb-4">
                <div className="d-flex justify-content-end">
                  <div className="input-group">
                    <input onChange={(e) => setSearch1Value(e.target.value)} type="text" className="form-control px-35px" placeholder="Search" />
                    <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                      <i className="fa fa-search opacity-5"></i>
                    </div>
                  </div>
                </div>
                <button className="btn btn-outline-default" type="submit">
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </form>

            {/* ----------------Table-------------- */}

            <div className="table-responsive">
              <table className="table table-hover text-nowrap">
                <thead>
                  <tr>
                    <th className="border-top-0 pt-0 pb-2">Training Title</th>
                    <th className="border-top-0 pt-0 pb-2">Training Code</th>
                    <th className="border-top-0 pt-0 pb-2">Instructor</th>
                    <th className="border-top-0 pt-0 pb-2">Start Date</th>
                    <th className="border-top-0 pt-0 pb-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {data.data.length > 0 ? (
                    data.data.map((val) => (
                      <tr key={val.id}>
                        <td className="align-middle">{val.trainingCode.title}</td>
                        <td className="align-middle">{val.trainingCode.code}</td>
                        <td className="align-middle">{val.instructorData.namaInstructor}</td>
                        <td className="align-middle">{DateFormat(val.startDate)}</td>
                        <td className="align-middle">
                          <Link to={`/training-evaluation-3/new-from-outstanding/${val.id}`} title="add to Tel 3">
                            <MdFormatListBulletedAdd />
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>no data</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* ----------------End Table-------------- */}
          </div>

          {/* ----------------End All Tab------------------------------------------------------------------ */}
          {data.meta ? <Pagination3 pageInfo={data} nextClick={handleNextClick} prevClick={handlePrevClick} /> : ""}
        </div>
      </Card>
    </>
  );
}

export default DataOutstanding;
